<template>
  <SlottedDialog :externaltrigger="externaltrigger" :externalCloseTrigger="externalCloseTrigger"
    :title="'New contract detail'">
    <template v-slot:content>
      <v-form v-model="valid">
        <ContractDetailTypeControl :key="externaltrigger" :detail="draft" :isParentDetail="!parentDetail"
          :contract="contract">
        </ContractDetailTypeControl>
      </v-form>
    </template>

    <template v-slot:buttons>
      <v-btn outlined @click="$emit('RequestClose')">
        {{ $t('servicesystem.common_objects.commonterms.cancel') }}
      </v-btn>
      <v-spacer />
      <v-btn color="primary" :disabled="!draft || !valid" :loading="createLoading" @click="create()">
        {{ $t('servicesystem.common_objects.commonterms.create') }}
      </v-btn>
    </template>
  </SlottedDialog>
</template>

<script>
import SlottedDialog from "@/views/layouts/SlottedDialog.vue";
import clientAPI from "@/api/ClientAPIMixin.js";
import rules from "@/helpers/Mixins/QInputRuleMixin.js";
import ContractDetailTypeControl from "@/views/contracts/ContractDetailTypeControl.vue";

const emptyDraft = { CustomerId: null, MachineId: null, Article: null, ArticleId: null, Price: null, Qty: 1 };

export default {
  name: "NewContractDetailDialog",
  props: {
    externaltrigger: Number,
    externalCloseTrigger: Number,
    contract: Object,
    parentDetail: Object,
  },
  components: {
    SlottedDialog,
    ContractDetailTypeControl,
  },
  mixins: [clientAPI, rules],

  data() {
    return {
      valid: false,
      createLoading: false,
      draft: {
        CustomerId: null,
        MachineId: null,
        Article: null,
        ArticleId: null,
        Price: null,
        Qty: 1,
      },
    };
  },

  methods: {
    enforceMaxLength(str, maxLength) {
      if (str && (str.length > maxLength)) {
        return str.substring(0, maxLength);
      }
      return str || "";
    },

    async create() {
      if (!this.draft) {
        return;
      }
      this.createLoading = true;
      const today = new Date();
      const addMonths = (d, m) => {
        const dt = new Date(d.getTime());
        dt.setMonth(dt.getMonth() + m);
        return dt;
      };

      const payload = {
        ContractId: this.contract?.Id ?? null,
        ParentDetailId: this.parentDetail?.Id ?? null,
        ContractArticleId: this.draft.ContractArticleId,
        ArticleId: this.draft.Article?.Id,
        ContractDetailGroup: this.enforceMaxLength(this.draft.Article?.ArticleDescription, 50),
        Qty: this.draft.Qty || 1,
        PriceModelId: 2,
        Price: this.draft.Price != null ? Number(this.draft.Price) : null,
        CustomerId: this.draftCustomerId,
        MachineId: this.draft.MachineId ?? null,
        ContractStart: today,
        ContractLengthMonths: 12,
        ContractEnd: addMonths(today, 12),
        ContractValid: true,
        InvoiceLengthMonths: 12,
        NextInvoiceStartDate: today,
        NextInvoiceEndDate: addMonths(today, 12),
        ContractDetailArticleSalesText: '',
        ContractDetailArticleDiscount: 0,
      };

      await this.createContractDetail(payload)
        .then(response => {
          this.$emit('Added', response);
          this.createLoading = false;
          this.$emit('RequestClose');
        })
        .catch((e) => {
          this.createLoading = false;
          console.error('createContractDetail', e)
        })
    },

    ensureDraft() {
      if (!this.draft) {
        this.draft = Object.assign({}, emptyDraft);
      }
    },
  },

  computed: {
    articleDialogFilter() {
      const customerId = this.draftCustomerId;
      return customerId ? { CustomerId: customerId } : null;
    },

    selectedDraftArticle: {
      get() {
        return this.draft?.Article || null;
      },
      set(value) {
        this.ensureDraft();
        this.$set(this.draft, 'Article', value);
        this.$set(this.draft, 'ArticleId', value?.Id);
        if (value && (value.ArticlePrice != null || value.ArticlePriceOut != null || value.Price != null)) {
          const p = value.ArticlePrice ?? value.ArticlePriceOut ?? value.Price ?? null;
          if (p != null) this.$set(this.draft, 'Price', p);
        }
      }
    },

    draftCustomerId: {
      get() {
        if (this.draft && this.draft.CustomerId !== undefined && this.draft.CustomerId !== null) {
          return this.draft.CustomerId;
        }
        return this.contract?.CustomerId ?? this.contract?.Customer?.Id ?? null;
      },
      set(value) {
        this.ensureDraft();
        this.$set(this.draft, 'CustomerId', value);
      }
    },

    draftMachineId: {
      get() {
        return this.draft?.MachineId ?? null;
      },
      set(value) {
        this.ensureDraft();
        this.$set(this.draft, 'MachineId', value);
      }
    }
  },

  watch: {}
};
</script>

<style lang="scss" scoped></style>
